module.exports = __webpack_public_path__ + "static/media/bu-target.9a1a1d92.svg";